import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { showNotifySuccess, showNotifyError } from "services/toaster";
import InviteService from "modules/notifications/api/InviteService";
import { userInfo } from "projects/store/users.selectors";

import ConfirmationDialog from "components/Dialogs/ConfirmationDialog";
import ConfirmationText from "components/Dialogs/ConfirmationText";
import { Menu, MenuItem } from "components";

import { ControlsWrapper } from "./styles";
import LocationForm from "../LocationForm";
import MyCompanyService from "../../../api/MyCompanyService";

const stopPropagation = (event) => {
  event.stopPropagation();
};

const Controls = ({ location, onSuccess }) => {
  const [deleteDialog, setDeleteDialog] = useState(null);
  const [editDialog, setEditDialog] = useState(null);

  function handleLocationEditClick() {
    const { id, fullName } = location;

    setEditDialog({ id, fullName });
  }

  function closeEditDialog() {
    setEditDialog(null);
  }

  function closeDeleteDialog() {
    setDeleteDialog(null);
  }

  async function handleEditConfirm(values) {
    const response = await MyCompanyService.updateInsuranceCompanyLocationInfo(values);

    if (!response.fieldErrors) {
      showNotifySuccess("Location was successfully updated.");
      closeEditDialog();
      if (onSuccess) onSuccess();
    }

    return response;
  }

  async function handleDeleteConfirm() {
    const response = await MyCompanyService.deleteInsuranceCompanyLocationById(deleteDialog.id);

    if (!response.fieldErrors) {
      showNotifySuccess(`${deleteDialog.name} was successfully deleted from your company.`);
      closeEditDialog();
      if (onSuccess) onSuccess();
    }

    return response;
  }

  return (
    <ControlsWrapper onClick={stopPropagation}>
      <Menu>
        <MenuItem icon="edit" text="Edit" onClick={handleLocationEditClick} />
        {/* <MenuItem
          icon="deleteSmall"
          text="Delete"
          onClick={handleContactDeleteClick}
          /> */}
      </Menu>

      {deleteDialog && (
        <ConfirmationDialog
          open
          title="Delete Location"
          confirmButtonTitle="Delete"
          onClose={closeDeleteDialog}
          onCancel={closeDeleteDialog}
          onConfirm={handleDeleteConfirm}
        >
          {deleteDialog.deleteConfirmationText}
        </ConfirmationDialog>
      )}

      {editDialog && (
        <LocationForm
          isOpen
          mode="edit"
          onCancel={closeEditDialog}
          onSubmit={handleEditConfirm}
          onClose={closeEditDialog}
          location={location}
        />
      )}
    </ControlsWrapper>
  );
};

export default Controls;
